// Resource.Content — opaque branded content payload.
//
// Slice 2 keeps content deliberately opaque: `ResourceContent` is a
// branded string the shell fills before dispatch. `Shape` + `Style`
// + rich `Content` are Slice 5+ territory (Templates + Packaging).
// For now the core only needs *something* to store and re-emit; the
// brand is enough to keep raw strings from sneaking in unparsed.
export { from, mk, to };
import { Result } from "@bilda/utils";
import * as IdError from "../idError.js";
const mk = (s) => s;
// Empty content is legal (a freshly-authored draft may have nothing
// yet). We reject control characters *outside* the standard textual
// whitespace (tab, LF, CR) so the round-trip through a text-oriented
// bundle stays safe; richer binary content is a Slice 5+ concern.
const to = (s) => {
    for (let i = 0; i < s.length; i++) {
        const code = s.charCodeAt(i);
        if (code === 0x09 || code === 0x0a || code === 0x0d) {
            continue;
        }
        if (code < 0x20 || code === 0x7f) {
            return Result.err(IdError.mkMalformed("ResourceContent", s));
        }
    }
    return Result.ok(mk(s));
};
const from = (c) => c;
//# sourceMappingURL=content.js.map